import { Directive, HostListener } from '@angular/core';

import { ZendeskService } from './zendesk.service';

// Created as directive, so if K&K wants to, they can add this directive to rich text elements, so they can open the chat from anywhere.
// In that case, one could add some kind of inline styling to the clicked item, when loading is in progress
@Directive({
    selector: '[appZendeskDirective]',
    standalone: true
})
export class ZendeskDirective {
    constructor(private readonly zendeskService: ZendeskService) {}

    @HostListener('click')
    public handleClick(): void {
        this.zendeskService.openChat();
    }
}
